import request from '../api';

// 获取模型列表
export function appProjectGetModel() {
  return request.post('/app/appProject/getModel');
}

// 获取模型的配置
export function appProjectGetModelProvider(params) {
  return request({
    url: '/app/appProject/getModelProvider',
    method: 'get',
    params,
  });
}

// 添加项目应用
export function appProjectAddProject(data) {
  return request({
    url: '/app/appProject/addProject',
    method: 'post',
    data,
  });
}
// 更新项目应用
export function appProjectUpdateProject(data) {
  return request({
    url: '/app/appProject/updateProject',
    method: 'post',
    data,
  });
}

// 获取App项目应用分页列表
export function appProjectGetAppAppProjectPage(data) {
  return request({
    url: '/app/appProject/getAppAppProjectPage',
    method: 'post',
    data,
  });
}

// 获取App项目应用详情
export function appProjectGetAppAppProject(id) {
  return request({
    url: `/app/appProject/getAppAppProject/${id}`,
    method: 'post',
  });
}

// 删除项目应用
export function appProjectDeleteAppProject(id) {
  return request({
    url: `/app/appProject/deleteAppProject/${id}`,
    method: 'post',
  });
}
